import { find } from 'lodash-es';

const _isParent = (navItem, navigationChannels) => {
  return navItem.parentId !== null && !!find(navigationChannels, ['parentId', navItem.id]);
};

var sanitizeHTML = (str) => {
  var temp = document.createElement('div');
  temp.textContent = str;
  return temp.innerHTML;
};

export const calculateWidth = (navItem, navigationChannels) => {
  let sideWidth,
    arrowWidth,
    element = document.getElementById('navitem-content');
  const NAV_PADDINGS = 30,
    ARROW_DOWN_WIDTH = 20;

  element.innerHTML = sanitizeHTML(navItem.title);
  arrowWidth = _isParent(navItem, navigationChannels) ? ARROW_DOWN_WIDTH : 0;
  sideWidth = NAV_PADDINGS + arrowWidth;
  return element.offsetWidth + sideWidth;
};

export const separateNavItemsInMore = (navigationChannels, navigationRootChannels, availableWidth) => {
  let navBarWidth = 0;
  let navigationItems = { inNav: [], inMore: [] };
  const MORE_WIDTH = 92;
  const maxNavBarWidth = availableWidth;

  navigationRootChannels.forEach((navItem, index) => {
    navBarWidth += calculateWidth(navItem, navigationChannels);

    const entireNavBarWidth = index + 1 === navigationRootChannels.length ? navBarWidth : navBarWidth + MORE_WIDTH;

    if (entireNavBarWidth <= maxNavBarWidth) {
      navigationItems.inNav.push(navItem);
    } else {
      navigationItems.inMore.push(navItem);
    }
  });

  return navigationItems;
};
